import React from 'react';
import { Button } from '@/components/ui/button';
import { Building2, ArrowLeft } from 'lucide-react';
import tokenStore from '@/utils/tokenStore';

export const getImpersonatingOrg = () => {
  try { return JSON.parse(sessionStorage.getItem('impersonating_org')); } catch (e) { return null; }
};

const returnToSuperAdmin = () => {
  const superToken = sessionStorage.getItem('_sa_return');
  if (!superToken) return;
  tokenStore.setToken(superToken);
  sessionStorage.removeItem('_sa_return');
  sessionStorage.removeItem('impersonating_org');
  window.location.href = '/organizations';
};

export default function ImpersonationBanner({ org }) {
  if (!org) return null;
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-2 flex items-center justify-between shadow-lg" data-testid="impersonation-banner">
      <div className="flex items-center gap-2">
        <Building2 className="h-4 w-4" />
        <span className="text-sm font-semibold">{`Vous etes connecte en tant que ${org.name}`}</span>
      </div>
      <Button size="sm" variant="secondary" onClick={returnToSuperAdmin} className="bg-white text-orange-700 hover:bg-orange-50 text-xs">
        <ArrowLeft className="h-3 w-3 mr-1" /> Retour Super Admin
      </Button>
    </div>
  );
}
